var map = {
	"./Icons/female.svg": 5600,
	"./Icons/femaleCondition.svg": 7487,
	"./Icons/femaleDeceased.svg": 5646,
	"./Icons/femaleDeceasedCondition.svg": 933,
	"./Icons/femaleSelf.svg": 6230,
	"./Icons/femaleSelfCondition.svg": 6621,
	"./Icons/male.svg": 263,
	"./Icons/maleCondition.svg": 2610,
	"./Icons/maleDeceased.svg": 5813,
	"./Icons/maleDeceasedCondition.svg": 5680,
	"./Icons/maleSelf.svg": 1805,
	"./Icons/maleSelfCondition.svg": 7080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6970;